module.exports = __webpack_public_path__ + "static/sunweb-skin-f3180e7360c6a9e7420728547e4f6922.jpg";